import {Service, Module} from 'app/decorators';
import R from 'app/resource';
import TokenServce from './token';

@Module({
    name: "app.services.auth",
    modules: [R, TokenServce],
})
@Service("AuthService")
export default class AuthService {
    constructor (R, TokenService) {
        "ngInject";
        this.R = R;
        this.TokenService = TokenService;
    }

    login (email, password) {
        var self = this;
        var data = {username: email, password: password};
        return this.R.all('token').customPOST(data).then(
            function(data){
                self.TokenService.set(data.token);
                return true;
            },
            function(){
                self.TokenService.clear();
                return false;
            }
        );
    }

    logout () {
        var self = this;
        self.TokenService.clear();
    }

    resetPassword (email) {
        let self = this;
        let $promise = this.R.one('users', 'password').post('reset', {
            email: email
        });

        // In case if user somehow has token
        $promise.then(() => { self.TokenService.clear(); });

        return $promise
    }

    changePassword (data) {
        return this.R.one('users', 'me').one('password').post('change', data);
    }

    confirmReset (data) {
        let $promise = this.R.one('users', 'password').one('reset').post('confirm', data);
        return $promise;
    }

    get isLoggedIn() {
        var self = this;
        return !!self.TokenService.get();
    }
}



// WEBPACK FOOTER //
// ./src/app/services/auth.js